import { render, staticRenderFns } from "./Logistics.vue?vue&type=template&id=966ba87c&scoped=true&"
import script from "./Logistics.vue?vue&type=script&lang=js&"
export * from "./Logistics.vue?vue&type=script&lang=js&"
import style0 from "./Logistics.vue?vue&type=style&index=0&id=966ba87c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966ba87c",
  null
  
)

export default component.exports